export enum VehiclesSort {
    CARRIER_NAME_ASC = 'carrierName',
    NAME_ASC = 'name',
    LICENSE_PLATE_ASC = 'licensePlate',
    TYPE_ASC = 'type',
    DETAILS_BRAND_ASC = 'details.brand',
    DETAILS_EMPTY_WEIGHT_ASC = 'details.emptyWeight',
    DETAILS_MAX_WEIGHT_ASC = 'details.maxWeight',
    DEVICE_LAST_REPORT_TIMESTAMP_ASC = 'device.lastReport.timestamp',
    TAGS_ASC = 'tags',
    CARRIER_NAME_DESC = '-carrierName',
    NAME_DESC = '-name',
    LICENSE_PLATE_DESC = '-licensePlate',
    TYPE_DESC = '-type',
    DETAILS_BRAND_DESC = '-details.brand',
    DETAILS_EMPTY_WEIGHT_DESC = '-details.emptyWeight',
    DETAILS_MAX_WEIGHT_DESC = '-details.maxWeight',
    DEVICE_LAST_REPORT_TIMESTAMP_DESC = '-device.lastReport.timestamp',
    TAGS_DESC = '-tags',
}
